import React from "react";
import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);
    const isPasswordType = type === "password";
    const isTemporalType =
      type === "date" ||
      type === "datetime-local" ||
      type === "time" ||
      type === "month" ||
      type === "week";

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    // Trigger native picker when temporal input is clicked
    const handleTemporalInputClick = (
      e: React.MouseEvent<HTMLInputElement>
    ) => {
      // showPicker is supported on Chrome-based browsers
      if (isTemporalType && (e.currentTarget as any).showPicker) {
        (e.currentTarget as any).showPicker();
      }
    };

    return (
      <div className="relative">
        <input
          type={isPasswordType && showPassword ? "text" : type}
          className={cn(
            "placeholder:text-black-grey-05 flex h-12 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            (isPasswordType || isTemporalType) && "pr-10", // Add padding for icons/pickers
            className
          )}
          ref={ref}
          onClick={handleTemporalInputClick} // Make whole input clickable for temporal inputs
          {...props}
        />
        {/* Password toggle button */}
        {isPasswordType && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? (
              <EyeOff className="h-5 w-5" />
            ) : (
              <Eye className="h-5 w-5" />
            )}
          </button>
        )}
        {/* Optional: Add calendar icon for date inputs */}
        {/* {isDateType && (
          <button
            type='button'
            onClick={(e) => {
              if (ref && 'current' in ref && ref.current) {
                ref.current.showPicker();
              }
            }}
            className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none'
            aria-label='Open calendar'
          >
            <Calendar
              className='h-5 w-5'
              onClick={(e) => {
                if (ref && 'current' in ref && ref.current) {
                  ref.current.showPicker();
                }
              }}
            />{' '}
          </button>
        )} */}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
